import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import * as ld from 'lodash';
import { bindActionCreators } from '../../app.store.jsx';
import FormComponent from '../FormComponent.jsx';
import DontKnowBtn from '../dont.know.btn/dont.know.btn.jsx';
import {
    initAjaxAutocomplete, fetchAutocompleteData, initAutocompleteData, setAutocompleteText, removeAjaxAutocomplete,
    AUTOCOMPLETE_STATUS_PENDING, AUTOCOMPLETE_STATUS_IDLE, CONCEPT_SERVICE, QUESTIONNAIRE_SERVICE
} from './reducer.jsx';
import { getPropsOrDefault, isEmptyValue, KEY_CODES, compareObjectsInclusive, compareObjects } from '../../../common/utils.jsx';
import { EMPTY_OBJECT, EMPTY_ARRAY, EMPTY_STRING } from '../../questionnaire.utils.jsx';
import dropdownStyle from '../dropdown/dropdown.less';
import textInputStyle from '../text.input/text.input.less';
import autocompleteStyle from './autocomplete.less';


export class AjaxAutocompleteItem extends PureComponent {
    constructor() {
        super();
        this.onClickHandler = this.onClickHandler.bind(this);
    }

    onClickHandler() {
        const { name, value } = this.props;
        this.props.onClickCallback(value, name);
    }
    render() {
        const { name, value, itemClass } = this.props;
        return (
            <li className={dropdownStyle.dropdownItemWrapper} onClick={this.onClickHandler} key={value}>
                <a tabIndex="0" className={itemClass}>
                    <span className={dropdownStyle.itemText}>{name}</span>
                </a>
            </li>
        );
    }
}

const UNKNOWN = 'UNKNOWN';
export class AjaxAutocomplete extends FormComponent {
    constructor(props) {
        super(props);
        this.closeMenu = this.closeMenu.bind(this);
        this.onInputUpdate = this.onInputUpdate.bind(this);
        this.getInputText = this.getInputText.bind(this);
        this.getOptions = this.getOptions.bind(this);
        this.getAllOptions = this.getAllOptions.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.setAutocompleteText = this.setAutocompleteText.bind(this);
        this.onBlurHandler = this.onBlurHandler.bind(this);
        this.onFocusHandler = this.onFocusHandler.bind(this);
        this.onKeyPressHandler = this.onKeyPressHandler.bind(this);
        this.optionClickHandler = this.optionClickHandler.bind(this);
        this.buildOptionsList = this.buildOptionsList.bind(this);
        this.buildOption = this.buildOption.bind(this);
        this.collectPayload = this.collectPayload.bind(this);
        this.getName = this.getName.bind(this);
        this._initAjaxAutocomplete = bindActionCreators(initAjaxAutocomplete);
        this._initAutocompleteData = bindActionCreators(initAutocompleteData);
        this._fetchAutocompleteData = bindActionCreators(fetchAutocompleteData);
        this._setAutocompleteText = bindActionCreators(setAutocompleteText);
        this.state = { active: false, menuPointer: null };

        const { prefetch, service } = this.props;
        const name = this.getName();
        this._initAjaxAutocomplete(name);
        const options = this.getAllOptions(false);
        if (prefetch && false === options) {
            const payload = this.collectPayload(EMPTY_STRING);
            this._initAutocompleteData(name, service, payload);
        }
        AjaxAutocomplete.__instances.push(this);
    }
    static isStorageSame(currentStorage, nextStorage) {
        const storageExist = undefined !== currentStorage && undefined !== nextStorage;
        if (!storageExist) { return false; }

        const fullListExist = undefined !== currentStorage.fullList && undefined !== nextStorage.fullList;
        if (!fullListExist) { return false; }

        const differentFullListLength = currentStorage.fullList.length !== nextStorage.fullList.length;
        if (differentFullListLength) { return false; }

        const cacheExist = undefined !== currentStorage.cache && undefined !== nextStorage.cache;
        if (!cacheExist) { return false; }

        const differentCacheLength = Object.keys(currentStorage.cache).length !== Object.keys(nextStorage.cache).length;

        return !differentCacheLength;
    }
    static counter(value, min, max, direction) {
        const INC = direction === AjaxAutocomplete.INC;
        const DEC = direction === AjaxAutocomplete.DEC;
        const isNull = null === value || undefined === value;
        if (isNull && DEC) { return max - 1; }
        if (isNull && INC) { return 0; }
        if (value <= min && DEC) { return max - 1; }
        if (value < min && INC) { return 0; }
        if (value < max && DEC) { return value - 1; }
        if (value < max - 1 && INC) { return value + 1; }
        if (value >= max - 1) { return 0; }
    }
    static closeAllOpenMenus(event) {
        const instances = AjaxAutocomplete.__instances;
        const instancesCount = instances.length;
        let instanceIndex = 0;
        let currentInstance = null;
        for (; instanceIndex < instancesCount; instanceIndex++) {
            currentInstance = instances[instanceIndex];
            const isDifferentInput = currentInstance.props.id.toString() !== event.target.id;
            if (currentInstance.state.active && isDifferentInput) {
                currentInstance.closeMenu(event);
            }
        }
    }
    static getStorage(src, storageName) {
        return src && src.autocomplete && src.autocomplete.__storage__ && src.autocomplete.__storage__[storageName] || EMPTY_OBJECT;
    }
    static getComponentState(src, storageName) {
        return src && src.autocomplete && src.autocomplete[storageName] || EMPTY_OBJECT;
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { storageName, components, conceptType, variants } = this.props;

        //Don't use getPropsOrDefault here to improve performance
        const currentComponentState = AjaxAutocomplete.getComponentState(components, storageName);
        const updatedComponentState = AjaxAutocomplete.getComponentState(nextProps.components, storageName);
        const componentIsUpdated = currentComponentState !== updatedComponentState;
        if (componentIsUpdated) { return true; }

        if (!variants) {
            const currentStorage = AjaxAutocomplete.getStorage(components, conceptType);
            const updatedStorage = AjaxAutocomplete.getStorage(nextProps.components, conceptType);
            const storageAreSame = AjaxAutocomplete.isStorageSame(currentStorage, updatedStorage);
            if (!storageAreSame) { return true; }
        }

        const componentStateIsUpdated = compareObjects(this.state, nextState);
        if (componentStateIsUpdated) { return true; }

        return compareObjectsInclusive(this.props, nextProps, [
            'value', 'variants', 'showAll', 'disabled', 'placeholder', 'name', 'service', 'storageName'
        ]);
        /*
        * Fields list:
        * prefetch, service, storageName, value, componentName, wrapperStyle, placeholder
        * name, components, conceptType, variants, showAll, disabled, unknownAccepted
        *
        * Will change:
        *  value, variants, showAll, disabled, components, placeholder
        * Usually will not change:
        *  prefetch, service, storageName, componentName, wrapperStyle, name, conceptType, unknownAccepted
        * */
    }

    componentWillUnmount() {
        removeAjaxAutocomplete(this.getName());
        const instanceIndex = AjaxAutocomplete.__instances.indexOf(this);
        if (-1 !== instanceIndex) {
            AjaxAutocomplete.__instances.splice(instanceIndex, 1);
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const optionsCount = this.getOptions().length;
        const nextOptionsCount = this.getOptions(nextProps).length;
        if (optionsCount !== nextOptionsCount) { this.setState({ menuPointer: null }); }
    }
    UNSAFE_componentWillUpdate(nextProps) {
        const { storageName, value, prefetch } = this.props;
        const { components } = nextProps;
        const isInvitaeCode = ('string' === typeof value) && value.includes('Invitae');
        if ((isInvitaeCode && isNaN(parseInt(value))) || undefined === value || null === value) {
            return;
        }
        const instanceStorage = AjaxAutocomplete.getStorage(components, storageName);

        if (prefetch && instanceStorage.fullList) { return; }
        const idMap = instanceStorage.idMap || EMPTY_OBJECT;
        const textValueFromMap = idMap[value] && idMap[value][name] || EMPTY_STRING;
        const currentTextValue = this.getInputText();
        if (textValueFromMap && currentTextValue !== textValueFromMap) { this.setAutocompleteText(textValueFromMap); }
        if (undefined === textValueFromMap) { this.fetchData(value); }
    }
    getName() {
        return this.props.componentName || this.props.name;
    }
    onInputUpdate(event) {
        const { components, storageName, prefetch } = this.props;
        const value = event.target.value;
        const lowerCaseValue = value.toLowerCase();
        const storage = AjaxAutocomplete.getStorage(components, storageName);
        let options, fieldValue;
        if (prefetch) {
            options = ld.filter(storage.fullList, ({ name }) => ld.startsWith(name.toLowerCase(), lowerCaseValue));
            fieldValue = value;
        } else {
            options = getPropsOrDefault(storage, `cache.${value}`, false);
            fieldValue = getPropsOrDefault(storage, `nameMap.${value}`, value);
        }
        if (false === options && storageName) { this.fetchData(value); }
        this.onChangeHandler(fieldValue);
        this.setAutocompleteText(value);
    }
    onKeyPressHandler(event) {
        const isActive = this.state.active;
        if (!isActive) { return true; }
        const options = this.getOptions();
        const optionsCount = options.length;
        let menuPointer = this.state.menuPointer;
        const keyCode = event.keyCode;
        const input = ReactDOM.findDOMNode(this);
        const dropDownItemHeight = 26;
        const dropDownMenuHeight = 200;
        const dropDownMenuCenter = Math.floor(dropDownMenuHeight / dropDownItemHeight / 2);
        if (keyCode === KEY_CODES.ARROW_DOWN) {
            menuPointer = AjaxAutocomplete.counter(menuPointer, 0, optionsCount, AjaxAutocomplete.INC);
            input.childNodes[1].scrollTop = dropDownItemHeight * (menuPointer - dropDownMenuCenter);
        } else if (keyCode === KEY_CODES.ARROW_UP) {
            menuPointer = AjaxAutocomplete.counter(menuPointer, 0, optionsCount, AjaxAutocomplete.DEC);
            input.childNodes[1].scrollTop = dropDownItemHeight * (menuPointer - dropDownMenuCenter);
        } else if (keyCode === KEY_CODES.ENTER) {
            const inputText      = event.target.value;
            const selectedOption = options[menuPointer];
            if (selectedOption) {
                this.onChangeHandler(selectedOption.value);
                this.setAutocompleteText(selectedOption.name);
            } else {
                const writtenOption = this.getAllOptions().find(({ name }) => name === inputText);
                if (writtenOption) {
                    this.onChangeHandler(writtenOption.value);
                    this.setAutocompleteText(writtenOption.name);
                } else {
                    this.onChangeHandler(inputText);
                    this.setAutocompleteText(inputText);
                }
            }
            this.setState({ menuPointer: null, active: false });
            return true;
        } else if (keyCode === KEY_CODES.TAB) {
            this.setState({ menuPointer: null, active: false });
            return true;
        } else {
            return true;
        }
        this.setState({ menuPointer });
        event.preventDefault();
    }
    onBlurHandler() { this.setState({ active: false }); }
    onFocusHandler() { this.setState({ active: true }); }
    collectPayload(value) {
        const payload = {
            storageName: this.props.storageName,
            value: this.props.value
        };
        switch (this.props.service) {
            case CONCEPT_SERVICE:
                payload.string = value;
                payload.conceptType = this.props.conceptType;
                break;
            case QUESTIONNAIRE_SERVICE:
                payload.string = value;
                break;
            default:
                throw new TypeError(`Unknown service: ${this.props.service}`);
        }
        return payload;
    }
    fetchData(value) {
        let _value = value;
        if ('string' === typeof _value) { _value = _value.trim(); }
        if (isEmptyValue(_value)) { return; }
        const payload = this.collectPayload(_value);
        this._fetchAutocompleteData(this.getName(), this.props.service, payload);
    }
    setAutocompleteText(value) { this._setAutocompleteText(this.getName(), value); }
    closeMenu() {
        //Because native event listener that close menu triggers before onClick on option
        //We put callback in setTimeout to make it called later
        setTimeout(() => { this.setState({ active: false }); }, 0);
    }
    getInputText(src) {
        const { variants, value } = this.props;
        const invitaeCode = 'Invitae';
        if ('string' === typeof value && value.includes(invitaeCode)) {
            const variant = ld.find(variants, (item) => item.value === value);
            return variant ? variant.name : EMPTY_STRING;
        }
        if (value && 'string' === typeof value) { return value; }
        const name = this.getName();
        const _src = src || this.props.components;
        return AjaxAutocomplete.getComponentState(_src, name).text || EMPTY_STRING;
    }
    getOptions(src) {
        const { storageName, variants, prefetch, showAll } = this.props;
        const name = this.getName();
        const _src = src || this.props.components;
        const inputText = String(this.getInputText(_src));
        const storage = AjaxAutocomplete.getStorage(_src, storageName);
        const lowercaseName = inputText.toLowerCase();
        let currentOptions;
        if (variants) {
            if (showAll && isEmptyValue(inputText)) { return variants; }
            if (!isEmptyValue(inputText)) {
                return ld.filter(variants, ({ name: itemName }) => ld.startsWith(itemName.toLowerCase(), lowercaseName));
            }
            return variants;
        }
        //currentOptions can be an empty array and it's valid value
        //To avoid disappearing dropdown while data is loading, we check for previous text value
        //and search values for it
        if (EMPTY_STRING === inputText) { return storage.fullList || EMPTY_ARRAY; }
        const prevText = AjaxAutocomplete.getComponentState(_src, name).prevText || EMPTY_STRING;
        if (!currentOptions && EMPTY_STRING !== prevText) {
            currentOptions = storage && storage.cache && storage.cache[prevText] || EMPTY_ARRAY;
        }
        if (prefetch) {
            currentOptions = ld.filter(storage.fullList, (item) => ld.startsWith(item.name.toLowerCase(), lowercaseName));
        } else {
            currentOptions = storage && storage.cache && storage.cache[inputText] || EMPTY_ARRAY;
        }
        return currentOptions;
    }
    getAllOptions(defaultValue = EMPTY_ARRAY) {
        const { storageName, variants, components } = this.props;
        if (variants) { return variants; }
        return AjaxAutocomplete.getStorage(components, storageName).fullList || defaultValue;
    }
    buildOptionsList(src) {
        const options = src || this.getOptions();
        return options.map(this.buildOption);
    }
    optionClickHandler(id, name) {
        this.setAutocompleteText(name);
        this.onChangeHandler(id);
    }
    buildOption(item, index) {
        const { value, name } = item;
        const currentItem = this.state.menuPointer;
        const itemClass = classNames(dropdownStyle.dropdownItem, { [dropdownStyle.active]: index === currentItem });
        return <AjaxAutocompleteItem key={value} value={value} name={name} itemClass={itemClass} onClickCallback={this.optionClickHandler}/>;
    }
    render() {
        const { placeholder, components, value, unknownAccepted, disabled, cssWrapperClass, wrapperStyle, id } = this.props;
        const name = this.getName();
        const inputText = UNKNOWN === value ? EMPTY_STRING : this.getInputText();
        const options = this.getOptions();
        const status = AjaxAutocomplete.getComponentState(components, name).status || AUTOCOMPLETE_STATUS_IDLE;
        const isDropdownOpen = this.state.active && (0 !== options.length || AUTOCOMPLETE_STATUS_PENDING === status);
        let dropdownClass;
        if (isDropdownOpen) {
            dropdownClass = classNames(dropdownStyle.autocompleteDropdownMenu, dropdownStyle.drowdownMenu, { [dropdownStyle.open]: isDropdownOpen });
        }
        const wrapperClass = classNames(dropdownStyle.wrapper, dropdownStyle.autocompleteWrapper, cssWrapperClass);
        const inputClass = classNames(textInputStyle.textInput, { [textInputStyle.disabled]: disabled });
        return (
            <div className={wrapperClass} style={wrapperStyle}>
                <input type="text" className={inputClass} onFocus={this.onFocusHandler} value={inputText} disabled={disabled}
                       id={id} placeholder={placeholder} onChange={this.onInputUpdate} onKeyDown={this.onKeyPressHandler}/>
                {
                    isDropdownOpen
                    ?   <div className={dropdownClass}>
                            <ul className={dropdownStyle.dropdownList}>
                                { this.buildOptionsList() }
                            </ul>
                        </div>
                    :   null
                }
                {
                    unknownAccepted
                        ? <DontKnowBtn disabled={disabled} wrapperClass={autocompleteStyle.dontKnowBtnWrapper} onChangeCallback={this.onChangeHandler} value={UNKNOWN} checked={ value === UNKNOWN }/>
                        : null
                }
            </div>
        );
    }
}
AjaxAutocomplete.INC = 1;
AjaxAutocomplete.DEC = -1;
AjaxAutocomplete.__instances = [];
document.body.addEventListener('click', AjaxAutocomplete.closeAllOpenMenus);
